import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=eb84aea0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Dictionary.vue?vue&type=script&lang=js&"
export * from "./Dictionary.vue?vue&type=script&lang=js&"
import style0 from "./Dictionary.vue?vue&type=style&index=0&id=eb84aea0&lang=stylus&scoped=true&"
import style1 from "./Dictionary.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb84aea0",
  null
  
)

export default component.exports